import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SalarieCompetenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto";
import $ from "jquery";
import moment from "moment";
import { DiplomeDto } from "../../../../../dto/GenApi.iNotPaie.Dto/DiplomeDto";

@Component
export default class ModalAjouterDiplome extends Vue {
	@Prop()
	public salarie?: SalarieCompetenceDto = undefined;

	public estAjout = false;
	public diplome?: DiplomeDto = undefined;

	public annee?: number = 0;
	public nom?: string = "";
	public habilitation?: string = "";
	public nomination?: string = "";
	public semestrialite?: number = 0;
	public seminaire?: number = 0;

	public onDiplomeChange(): void {
    	if (this.diplome == undefined) {
			return;
		}

    	this.annee = this.diplome.Annee;
    	this.nom = this.diplome.Nom;
    	this.habilitation = this.diplome.Habilitation != undefined ? moment.utc(this.diplome.Habilitation).format("YYYY-MM-DD") : "";
    	this.nomination = this.diplome.Nomination != undefined ? moment.utc(this.diplome.Nomination).format("YYYY-MM-DD") : "";
    	this.semestrialite = this.diplome.Semestrialite;
    	this.seminaire = this.diplome.Seminaire;
	}

	public initialize(diplome: DiplomeDto, estAjout: boolean, salarie?: SalarieCompetenceDto): void {
    	this.salarie = salarie;
    	this.estAjout = estAjout;
    	this.diplome = diplome;
    	this.onDiplomeChange();
	}

	public enregistrer(): void {
    	if (this.salarie == undefined || this.diplome == undefined || this.nom == undefined || this.nom == "") {
			return;
		}

    	this.diplome.Annee = this.annee;
    	this.diplome.Nom = this.nom;
    	this.diplome.Habilitation = this.habilitation != "" ? moment.utc(this.habilitation).toDate() : undefined;
    	this.diplome.Nomination = this.nomination != "" ? moment.utc(this.nomination).toDate() : undefined;
    	this.diplome.Semestrialite = this.semestrialite;
    	this.diplome.Seminaire = this.seminaire;

    	this.$emit(this.estAjout ? "ajout" : "update", { diplome: this.diplome });
    	$("#modalAjouterDiplome").modal("hide");
	}

	public annuler(): void {
    	$("#modalAjouterDiplome").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/competences/modals/ajouterDiplome/ajouterDiplome.ts